import { useT } from '../i18n/index.ts';
import { AnthropicLogo, GeminiLogo, OpenAILogo } from './logos/index.tsx';

/**
 * Provider row — a divider strip immediately below the hero that puts
 * OpenAI / Anthropic are live catalog families; Google Gemini is shown as
 * coming soon so the public page does not over-promise current ingress.
 *
 * DESIGN.md §6.3. Three inline SVG logos (via `logos/`), each paired
 * with the brand name in Inter medium. The strip is purely visual
 * reinforcement of current and planned model families — it is NOT a link
 * surface; clicking a logo doesn't navigate anywhere.
 */
export function ProviderRow(): JSX.Element {
  const t = useT();
  return (
    <section className="ghost-t ghost-b bg-linen" data-testid="provider-row">
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="flex flex-wrap items-center justify-center gap-x-14 gap-y-8 text-ink-soft">
          <div className="lift flex items-center gap-3">
            <OpenAILogo className="h-7 w-7 text-ink" />
            <span className="text-[15px] font-medium tracking-tight-ink">
              {t('providers.openai')}
            </span>
          </div>
          <div className="lift flex items-center gap-3">
            <AnthropicLogo className="h-7 w-7 text-ink" />
            <span className="text-[15px] font-medium tracking-tight-ink">
              {t('providers.anthropic')}
            </span>
          </div>
          <div className="lift flex items-center gap-3">
            <GeminiLogo className="h-7 w-7" />
            <span className="text-[15px] font-medium tracking-tight-ink">
              {t('providers.gemini')}
            </span>
            <span className="rounded-full border border-claude/20 bg-claude-tint px-2 py-0.5 font-mono text-[10px] font-medium uppercase tracking-[0.14em] text-claude-deep">
              {t('providers.coming_soon')}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
